<template>
<div class="content-account">
    <img v-if="$route.path.includes('panel')" src="../../assets/navbar/support.png" alt="">
    <img v-if="$route.path.includes('panel')" @click="$router.push('/notification')" src="../../assets/navbar/notification.png" alt="">
    <img v-if="$route.path.includes('panel')" @click="$router.push('/thekyc')" src="../../assets/navbar/user.png" alt="">
  <div v-if="$route.path.includes('panel')" class="Registered">
    <span>{{state.userInfo.firstName  }} {{state.userInfo.lastName}}</span>
  </div>
<template v-if="!state.token">
  <div v-if="!$route.path.includes('panel')" class="notRegister">
    <span @click="$router.push('/auth/login')">ورود</span> | <span @click="$router.push('/auth/register')">عضویت</span>
  </div>
</template>
 <template v-else>
   <span v-if="!$route.path.includes('panel')" @click="$router.push('/panel/dashboard')">ورود به حساب</span>
 </template>

</div>
</template>

<script>
export default {
  name: "the-account"
}
</script>

<style lang="scss" scoped>
.content-account{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  img{
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  span{
    font-size: clamp(14px , 2vw , 16px);
    cursor: pointer;
    &:hover{
      color: #FBFBFD;
    }
  };
}

//max width 992px
@media screen and (max-width: 992px) and (min-width: 460px){
  .content-account {
    justify-content: start;
    gap: 10px;
    width: max-content;
  }
}

@media (max-width: 500px){
  .content-account{
    width: auto !important;
    gap: 10px;
  }

  .Registered{
    display: none !important;
  }
}
</style>